/* eslint-disable no-param-reassign */
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { TextInlineEditMMA } from '@bingads-webui-campaign/asset-inline-edit';
import template from './text.pug';
import imageTemplate from './image.pug';
import videoTemplate from './video.pug';

export class ColumnAssetMMA extends CampaignuiBaseColumn {
  constructor({
    i18n, scope, view,
  }) {
    const title = i18n.getString('ColumnName_Asset');
    const adType = scope && scope.values && scope.values.adType;
    const helpId = {
      Responsive: 'pop_BA_MMA_Asset',
      DynamicSearch: 'pop_BA_DSA_Asset',
      DynamicResponsive: 'pop_BA_DSA_Asset',
    };

    super({
      name: 'Asset',
      property: 'Asset',
      sortable: 'Asset/Text',
      title,
      type: 'string',
      bodyClasses: 'grid-column-Asset',
      enableEdit: item => item.Asset.AssetType === 'Text' && item.Asset.AssetSource === 'AdvertiserProvided' && item.UiDisplayStatus === 'Active' && adType === 'Responsive',
      helpId: helpId[adType],
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });

    this.scope = scope;
    this.i18n = i18n;
    this.view = view;
  }

  get property() {
    return {
      get: ({
        Asset,
      }) => Asset,
    };
  }

  template({ value }) {
    if (value.AssetType === 'Image') {
      return imageTemplate({
        imageUrl: value.ImageUrl,
      });
    } else if (value.AssetType === 'Video') {
      const isVertical = value?.Height > value?.Width;
      return videoTemplate({
        imageUrl: value.ThumbnailUrl,
        isVerticalVideo: isVertical,
      });
    }

    return template({
      text: value.Text,
    });
  }

  onPrompt({
    item, newPosition,
  }) {
    return TextInlineEditMMA({
      item,
      newPosition,
      view: this.view,
      i18n: this.i18n,
      scope: this.scope,
      itemToSchemaMap: {
        ResponsiveAdHeadlines: 'Headline',
        ResponsiveAdDescriptions: 'Text',
        ResponsiveAdLongHeadlines: 'LongHeadline',
      },
      schemaToItemMap: {
        Headline: 'Headlines',
        Text: 'Descriptions',
        LongHeadline: 'LongHeadlines',
      },
    });
  }
}
